export default __webpack_public_path__ + "static/mica-zoom-bg-v2-a5b73c7dd768cb22cf352a97850ac26a.jpg";